import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {DoorService} from './door.service';

@Component({
  selector: 'app-door',
  imports: [],
  templateUrl: './door.html',
  styleUrl: './door.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Door {
  protected doorService = inject(DoorService);

  protected selected = this.doorService.selectedDoor;
  protected doors = this.doorService.availableDoors;
  protected colors = this.doorService.availableColors;

  setDoor(event: Event) {
    const select = event.target as HTMLSelectElement | null;
    if (select) {
      this.doorService.setDoor(select.value as any);
    }
  }

  setColor(event: Event) {
    const select = event.target as HTMLSelectElement | null;
    if (select) {
      this.doorService.setDoorColor(select.value);
    }
  }
}
